import React from 'react'

const Icon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
      <path
        d='M9.45817 13.5754H10.5415V10.3254H13.7915V9.24211H10.5415V5.99211H9.45817V9.24211H6.20817V10.3254H9.45817V13.5754ZM3.4165 16.3671V3.20044H16.5832V16.3671H3.4165ZM4.49984 15.2838H15.4998V4.28377H4.49984V15.2838Z'
        fill='white'
      />
    </svg>
  )
}

export default Icon
